import React from "react";
import moment from "jalali-moment";
import toast from "react-hot-toast";
import { Spinner, Toast } from "react-bootstrap";

const Form = ({ data, setData, setStep, step, CreateContract, loading }) => {
  const handlershowcomponent = () => {
    switch (step) {
      case 1:
        return <StepOne data={data} setData={setData} />;
        break;
      case 2:
        return <StepTwo data={data} setData={setData} />;
        break;
      case 3:
        return <StepThree data={data} setData={setData} />;
        break;
      case 4:
        return <Stepfour data={data} setData={setData} />;
        break;
    }
  };
  let keys = {
    1: [
      { key: "itemname", title: "نام باشگاه" },
      { key: "itemtype", title: " نوع مجموعه" },
      { key: "itemaddres", title: "آدرس مجموعه" },
      { key: "managername", title: " نام مدیر" },
      { key: "managermobile", title: " شماره همراه مدیر" },
      { key: "managerntinalcode", title: " کد ملی مدیر" },
    ],
    2: [
      { key: "netprice", title: "قیمت خرید نیکوتن" },
      { key: "bordprice", title: "قیمت فروش نیکوتن" },
    ],
    3: [
      { key: "bankname", title: "نام بانک" },
      { key: "banknumber", title: " شماره  حساب" },
      { key: "bankshaba", title: "شماره شبا" },
    ],
    4: [{ key: "signphoto", title: "امضا" }],
  };
  const Handlerstepplus = () => {
    let result = "";
    keys[step].map(key => {
      if (!data[key.key]) {
        result = result + (result == "" ? "" : " , ") + key.title;
      }
    });
    if (result == "") {
      if (step == 4) {
        CreateContract(data);
      } else {
        setStep(step + 1);
      }
    } else {
      if (step == 2 && data.itemtype != "pool") {
        setStep(step + 1);
      } else {
        toast.error(result + "  پر نشده است  ");
      }
    }
  };
  const Handlerbotum = () => {
    if (step == 4) {
      if (loading) {
        return (
          <Spinner
            as="span"
            animation="border"
            size="sm"
            role="status"
            aria-hidden="true"
          />
        );
      } else {
        return "ثبت";
      }
    } else {
      return "مرحله بعد";
    }
  };
  return (
    <div className="formcontract">
      <div className="head d-flex">
        <div style={{ flex: '1' }}>
          <div className="p-2 text-right">
            <span>مرحله ی اول | مشخصات فردی</span>
            <div
              className="progress custom-progress"
              style={{ marginTop: "15px", backgroundColor: "#d3d3d3" }}
            >
              <div
                className="progress-bar progress-bar-striped bg-danger progress-bar-animated"
                role="progressbar"
                style={{ width: step * 25 + "%" }}
                aria-valuenow={step * 25}
                aria-valuemin={0}
                aria-valuemax={100}
              />
            </div>
          </div>
        </div>
        <div className="p-2" >
          <img src={window.location.origin + "/img/logo/logo2.png"} width={'60px'} height={'60px'} />
        </div>
      </div>
      <div className="contect mt-4">
        {handlershowcomponent()}
      </div>
      <div className="row justify-content-evenly mt-4">
        <div className="col d-flex justify-content-center align-items-center">
          <button
            className="btn"
            style={{ backgroundColor: "rgb(30, 140, 59)", color: "#fff" }}
            disabled={step == 1 ? true : false}
            onClick={() => setStep(step - 1)}
          >
            مرحله قبل
          </button>
        </div>
        <div className="col  d-flex justify-content-center align-items-center">
          <button
            className="btn"
            style={{ backgroundColor: "rgb(228, 42, 63)", color: "#fff" }}
            onClick={Handlerstepplus}
          >
            {Handlerbotum()}
          </button>
        </div>
      </div>
    </div>
  );
};
export default Form;

const StepOne = ({ data, setData }) => {
  return (
    <>
      <div className="text-center">
        <h5>قرارداد همکاری در فروش نیکوتن</h5>
      </div>
      <div className="input-box row mt-2">
        <div className="col-md-8 d-flex boxinp justify-content-center align-items-center">
          <label>این قرارداد فی ما بین : </label>
          <input
            style={{ flex: 1, paddingRight: "5px", marginRight: '5px' }}
            placeholder="نام مجموعه"
            value={data.itemname}
            onChange={e => {
              setData({
                ...data,
                itemname: e.target.value,
              });
            }}
          ></input>
        </div>
        <div className="col-md-4 d-flex boxinp justify-content-center align-items-center">
          <label > نوع مجموعه : </label>
          <select
            style={{ flex: 1, padding: "1px", borderRadius: "5px", marginRight: '5px' }}
            onChange={({ target: { value } }) => {
              setData({
                ...data,
                itemtype: value,
              });
            }}
          >
            <option>انتخاب</option>
            <option selected={data.itemtype == "saloon"} value="saloon">
              سالن
            </option>
            <option selected={data.itemtype == "pool"} value="pool">
              استخر
            </option>
            <option selected={data.itemtype == "gym"} value="gym">
              باشگاه
            </option>
          </select>
        </div>
        <div className="col-md-8 d-flex boxinp justify-content-center align-items-center">
          <label > به آدرس : </label>
          <input
            style={{ flex: 1, paddingRight: "5px", marginRight: '5px' }}
            placeholder="آدرس مجموعه "
            value={data.itemaddres}
            onChange={e => {
              setData({
                ...data,
                itemaddres: e.target.value,
              });
            }}
          ></input>
        </div>
        <div className="col-md-4 d-flex boxinp justify-content-center align-items-center">
          <label> به نمایندگی:</label>
          <input
            style={{ flex: 1, paddingRight: "5px", marginRight: '5px' }}
            placeholder="نام مدیریت"
            value={data.managername}
            onChange={e => {
              setData({
                ...data,
                managername: e.target.value,
              });
            }}
          ></input>
        </div>
        <div className="col-md-6 d-flex boxinp justify-content-center align-items-center">
          <label > کد ملی :</label>
          <input
            style={{ flex: 1, paddingRight: "5px", marginRight: '5px' }}
            placeholder="کد ملی مدیریت"
            value={data.managerntinalcode}
            onChange={e => {
              setData({
                ...data,
                managerntinalcode: e.target.value,
              });
            }}
          ></input>
        </div>
        <div className="col-md-6 d-flex boxinp justify-content-center align-items-center">
          <label > شماره همراه :</label>
          <input
            style={{ flex: 1, paddingRight: "5px", marginRight: '5px' }}
            placeholder=" تلفن همراه مدیریت"
            value={data.managermobile}
            onChange={e => {
              setData({
                ...data,
                managermobile: e.target.value,
              });
            }}
          ></input>
        </div>
      </div>
      <div className="mt-3 textfotter">
        <p>
          که از این به بعد کارفرما نامیده می شود از یک طرف و شرکت ویداسیستم
          ایرانیان
          <span>
            <a href="http://nikotan.ir">( سامانه ورزشی نیکوتن به آدرس )</a>
          </span>{" "}
          به نمایندگی آقای سعید شوروزی به آدرس بلوار پژوهش، پارک علم و فناوری
          خراسان – مرکز رشد شهرستان نیشابور که از این پس کارشناس نامیده می شود
          از طرف دیگر منعقد میگردد .{" "}
        </p>
      </div>
    </>
  );
};

const StepTwo = ({ data, setData }) => {
  const Handleritemtype = () => {
    switch (data.itemtype) {
      case "pool":
        return "استخر";
        break;
      case "gym":
        return "باشگاه";
        break;
      case "saloon":
        return "سالن";
        break;
    }
  };
  const Handlercontracttype = () => {
    switch (data.itemtype) {
      case "pool":
        return (
          <div className="row">
            <div className="col-md-6 d-flex boxinp justify-content-center align-items-center">
              <label>قیمت خرید نیکوتن از شما : </label>
              <input
                style={{ flex: 1, paddingRight: "5px", marginRight: '5px' }}
                placeholder="به تومان"
                value={data.netprice}
                onChange={e => {
                  setData({
                    ...data,
                    netprice: e.target.value,
                  });
                }}
              ></input>
            </div>
            <div className="col-md-6 d-flex boxinp justify-content-center align-items-center">
              <label > قیمت فروش نیکوتن به کاربر : </label>
              <input
                style={{ flex: 1, paddingRight: "5px", marginRight: '5px' }}
                placeholder="به تومان"
                value={data.bordprice}
                onChange={e => {
                  setData({
                    ...data,
                    bordprice: e.target.value,
                  });
                }}
              ></input>
            </div>
          </div>
        );
        break;
      case "gym":
      case "saloon":
        return (
          <span className="rlm" style={{ marginRight: '10px' }}>
            مبلغ همکاری در فروش رزرو ها طبق قوانین شرکت<span style={{ color: 'red' }}> 10 </span> درصد
            از مبلغ هر رزرو می باشد.
          </span>
        );
        break;
    }
  };
  return (
    <>
      <div className="row">
        <div className="col-12">
          <h6> 1- موضوع همکاری :</h6>
          <div style={{ marginBottom: "10px" }}>
            <span style={{ marginRight: '10px' }}>
              همکاری در رزرو {Handleritemtype()} {data.itemname}
            </span>
          </div></div>
        <div className="col-12">
          <h6>2- مدت قرارداد :</h6>
          <div style={{ marginBottom: "10px" }}>
            <span style={{ marginRight: '10px' }}>
              از تاریخ {moment().locale("fa").format("YYYY/MM/DD")} به مدت یکسال
              شمسی می باشد.
            </span>
          </div>
        </div>
        <div className="col-12">
          <h6>3- مبلغ قرارداد :</h6>
          <div style={{ marginBottom: "10px" }}>{Handlercontracttype()}</div>
        </div>
      </div>
    </>
  );
};
const StepThree = ({ data, setData }) => {
  return (
    <div className="row">
      <div className="col-12">
        <h6> 4- نحوه پرداخت:</h6>
        <div style={{ marginBottom: "10px" }}>
          <span style={{ marginRight: '10px' }}>
            پس از ثبت درخواست و کسر مبلغ منعقد شده در بند سه از مبلع هر رزرو در
            کمتر از دو روز کاری به حساب مشخص شده
          </span>
        </div>
        <div className="row">
          <div className="col-md-4 d-flex boxinp justify-content-center align-items-center">
            <label className="rlm"> نام بانک : </label>
            <input
              className="rlm"
              style={{ flex: 1, paddingRight: "5px", marginRight: '5px' }}
              placeholder="نام بانک"
              value={data.bankname}
              onChange={e => {
                setData({
                  ...data,
                  bankname: e.target.value,
                });
              }}
            ></input>
          </div>
          <div className="col-md-8 d-flex boxinp justify-content-center align-items-center">
            <label className="rlm"> شماره حساب :</label>
            <input
              className="rlm"
              style={{ flex: 1, paddingRight: "5px", marginRight: '5px' }}
              placeholder="شماره حساب"
              value={data.banknumber}
              onChange={e => {
                setData({
                  ...data,
                  banknumber: e.target.value,
                });
              }}
            ></input>
          </div>
          <div className="col-md-12 d-flex boxinp justify-content-center align-items-center">
            <label className="rlm">َشماره شبا : </label>
            <input
              className="rlm"
              style={{ flex: 1, paddingRight: "5px", marginRight: '5px' }}
              placeholder="شماره شبا بدون IR ابتدا"
              value={data.bankshaba}
              onChange={e => {
                setData({
                  ...data,
                  bankshaba: e.target.value,
                });
              }}
            ></input>
          </div>

        </div>
      </div>
      <div className="col-12 mt-3 ">
        <h6>5- تعهدات کارشناس :</h6>
        <div style={{ marginBottom: "10px" }}>
          <p>
            5.1 کارشناس متعهد می گردد تمامی اطلاعات مجموعه های ورزشی و رزروها به
            صورت محرمانه باقی بماند.
            <br /> 5.2 کارشناس متعهد می گردد اطلاعات کامل افراد ثبت نام کننده را
            به کارفرما تحویل دهد.
          </p>
        </div>
      </div>
    </div>
  );
};

export const Stepfour = ({ data, setData }) => {
  return (
    <>
      <div className="row">
        <div className="col-12">
          <h6>6- تعهدات کارفرما :</h6>
          <div style={{ marginBottom: "10px" }}>
            <p style={{ marginRight: '10px' }}>
              1.6 ارسال درخواست کتبی در صورت نیاز به اعزام کارشناس
              <br />
              2.6 کارفرما متعهد می شود مستندات و داده های مورد نیاز کارشناس را طی دو
              روز کاری برای کارشناس و یا نماینده کارشناس ارسال کند.
              <br />
              3.6 کارفرما متعهد می شود تمامی اطلاعات مجموعه ورزشی را در اختیار
              کارشناس قرار دهد.
              <br />
              4.6 کارفرما متعهد می شود رزروهای سایت برای سانس های مجموعه ورزشی در
              اولویت باشد.
              <br />
              6.5 کارفرما متعهد می شود رزروهایی که از طریق سامانه انجام شده است در
              اولویت باشند.
              <br />
            </p>
          </div>
        </div>
        <div className="col-12">
          <div className="text d-flex align-items-center">
            <input
              type="checkbox"
              checked={data.signphoto}
              onChange={e => {
                setData({
                  ...data,
                  signphoto: !data.signphoto,
                });
              }}
            />
            <label style={{ marginRight: "10px" }}>
              اینجانب {data.managername} تمامی بند های قراداد را به دقت مطالعه کرده
              و با تمامی بند های آن موافقم و انتخاب این گزینه به منظر تایید و امضای
              این قرارداد میباشد .
            </label>
          </div>
        </div>
      </div>
    </>
  );
};
